<template>
    <span class="sort-caret-wrapper" :class="[{active: order},{show: prop === value}]">
        <i class="jc-icon icon-triangle-up"></i>
    </span>
</template>

<script>
export default {
    name: 'sort-caret',
    props: {
        prop: String, // 当value等于prop时高亮
        value: {
            type: String,
            required: true
        },
        order: {
            type: Boolean,
            default: true
        },
        reverse: Boolean
    }
}
</script>

<style lang="scss">
.sort-caret-wrapper {
    color: #409bff;
    display: inline-flex;
    justify-content: center;
    align-items: center;
    opacity: 0;
    vertical-align: middle;
    &.show {   
        opacity: 1;
    }
    &.active {
        i {transform: rotate(180deg)}
    }
    i {
        font-size: 24px;
        line-height: 1;
        margin-left: 0!important;
        transition: unset!important;
    }
}
</style>



// WEBPACK FOOTER //
// src/components/filters/sort-caret.vue